import React, { useState, useEffect } from 'react';
import './NewContactForm.css';
import firebase from 'firebase';
import ContactsKeys from './ContactsKeys';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const formatTime = (firebaseTimestamp) => {
  if (!firebaseTimestamp) return '--:--';
  const date = new Date(firebaseTimestamp.seconds * 1000);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  hours = hours < 10 ? '0' + hours : hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  return `${hours}:${minutes}`;
};

function NewContactForm({ onUpdate, currentUser, showForm, closeForm, initialData, isEditing }) {
  const [contactName, setContactName] = useState('');
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [whatsappError, setWhatsappError] = useState('');
  const [searchKeys, setSearchKeys] = useState([]);

  const [dynamicFields, setDynamicFields] = useState([]);
  const [dynamicValues, setDynamicValues] = useState({});
  // Update email when it changes
  useEffect(() => {
    if (email) {
      console.log('Email updated:', email);
      // Handle the email update logic (e.g., send to the backend or validation)
    }
  }, [email]); // Will run every time the email state changes

  // Update whatsappNumber when it changes
  useEffect(() => {
    if (whatsappNumber) {
      console.log('WhatsApp number updated:', whatsappNumber);
      // Handle the WhatsApp number update logic (e.g., send to the backend or validation)
    }
  }, [whatsappNumber]); // Will run every time the whatsappNumber state changes
  useEffect(() => {
    if (initialData) {
      setContactName(initialData.name || '');
      setWhatsappNumber(initialData.phoneNumber || '');
      setEmail(initialData.email || '');
      setSearchKeys(initialData.keys || []);
      setDynamicValues((prev) => ({
        ...prev,
        ...initialData
      }));
    }

    axios
      .post('https://gambot.azurewebsites.net/api/Webhooks/GetDynamicContactColumns', {
        organization: currentUser.organization
      })
      .then((res) => {
        const data = res.data;

        // ✅ Ensure it's always an array
        if (Array.isArray(data)) {
          setDynamicFields(data);
        } else if (typeof data === 'object' && data !== null) {
          setDynamicFields(Object.entries(data).map(([key, val]) => ({ key, ...val })));
        } else {
          setDynamicFields([]);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch dynamic fields', err);
        setDynamicFields([]);
      });
  }, [initialData]);

  const handleSearchKeysChange = (newKeys) => {
    setSearchKeys(newKeys);
  };

  const handleDynamicChange = (key, value) => {
    setDynamicValues((prev) => ({
      ...prev,
      [key]: value
    }));
  };
  const handleContactNameChange = (e) => {
    setContactName(e.target.value);
  };

  const handleWhatsappNumberChange = (phone) => {
    setWhatsappNumber(phone);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = (e) => {
    e.preventDefault();
  
    let validEmail = true;
    let validWhatsapp = true;
  
    // Validate WhatsApp number
    if (!whatsappNumber) {
      setWhatsappError('WhatsApp phone number is required.');
      validWhatsapp = false;
    } else {
      setWhatsappError('');
    }
  
    // Validate Email
    if (email && !isEmailValid(email)) {
      setEmailError('Please enter a valid email address.');
      validEmail = false;
    } else {
      setEmailError('');
    }
  
    // 🧼 Clean dynamic values: remove any keys we handle separately
    const {
      email: __,            // remove email from dynamic values
      phoneNumber: ___,     // remove phoneNumber
      name: ____,           // remove name
      keys: _____,          // remove tags/search keys
      id: ______,           // optional: remove id just in case
      ...cleanedDynamicValues
    } = dynamicValues;
  
    if (contactName && validWhatsapp && validEmail) {
      const contactData = {
        organization: currentUser.organization,
        email: email,
        name: contactName,
        photoURL: '',
        lastMessage: isEditing ? 'Contact Updated' : 'New Contact Created',
        time: formatTime(firebase.firestore.Timestamp.now()),
        from: currentUser.wabaNumber,
        to: whatsappNumber.replace(/^\+/, ''),
        phoneNumber: whatsappNumber.replace(/^\+/, ''),
        id: whatsappNumber.replace(/^\+/, ''),
        keys: searchKeys,
        ...cleanedDynamicValues,
      };
  
      console.log('email', email);
      console.log('contactData:', contactData);
  
      const requestData = {
        organization: currentUser.organization,
        contactData: contactData,
        user: {
          userId: currentUser?.userId,
          userName: currentUser?.fullname || 'Gambot',
        },
      };
  
      const url = isEditing
        ? 'https://gambot.azurewebsites.net/api/Webhooks/UpdateContactById'
        : 'https://gambot.azurewebsites.net/api/Webhooks/CreateNewContact';
  
      axios.post(url, requestData)
        .then((response) => {
          if (response.data && response.data.Success) {
            onUpdate(response?.data?.Data);
            closeForm();
  
            // Reset form fields
            setContactName('');
            setWhatsappNumber('');
            setEmail('');
            setEmailError('');
            setWhatsappError('');
            setDynamicValues({});
          } else {
            console.error('Error saving contact:', response.data?.Message || 'Unknown error');
          }
        })
        .catch((error) => {
          console.error('Error saving document:', error);
        });
    }
  };
  

  const handleOutsideClick = (e) => {
    if (e.target.classList.contains('new-contact-form-modal')) {
      closeForm();
    }
  };

  return (
    <div className={`new-contact-form-modal ${showForm ? 'show' : ''}`} onClick={handleOutsideClick}>
      <div className="new-contact-form-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="new-contact-form-header">
          <h1>{isEditing ? 'Edit Contact' : 'New Contact Form'}</h1>
          <button className="new-contact-form-close-btn" onClick={closeForm}>
            &times;
          </button>
        </div>
        <div className="new-contact-form-scroll-wrapper">
        <form onSubmit={handleSubmit} className="new-contact-form">
          <div className="form-group">
            <label htmlFor="contactName">Contact Name:</label>
            <input
              type="text"
              id="contactName"
              value={contactName}
              onChange={handleContactNameChange}
              />
          </div>
          <div className="form-group">
            <label htmlFor="whatsappNumber">WhatsApp Phone Number:</label>
            <PhoneInput
              country={'il'}
              value={whatsappNumber}
              onChange={handleWhatsappNumberChange}
              inputProps={{
                name: 'whatsappNumber',
                required: true,
                autoFocus: true,
              }}
              enableSearch
              disableDropdown={false}
              placeholder="Enter phone number"
              containerClass="phone-input-container"
              inputClass="phone-input-field"
            />
            {whatsappError && <p className="error">{whatsappError}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={handleEmailChange}
              />
            {email && emailError && <p className="error">{emailError}</p>}
          </div>

          <div className="form-group">
            <label>Contact Group</label>
            <ContactsKeys onChange={handleSearchKeysChange} initialTags={searchKeys} />
          </div>

          {/* Dynamic Fields */}
          {dynamicFields
            .filter(field => field.showOnForm) // ✅ Only show fields where showOnForm is true
            .map((field, index) => (
              <div className="form-group" key={index}>
                <label>{field.label}</label>
                {field.type === 'text' || field.type === 'number' || field.type === 'date' ? (
                  <input
                    type={field.type}
                    value={dynamicValues[field.key] || ''}
                    onChange={(e) => handleDynamicChange(field.key, e.target.value)}
                  />
                ) : field.type === 'boolean' ? (
                  <select
                    value={dynamicValues[field.key] || ''}
                    onChange={(e) => handleDynamicChange(field.key, e.target.value === 'true')}
                  >
                    <option value="">Select</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                ) : field.type === 'select' && Array.isArray(field.options) ? (
                  <select
                    value={dynamicValues[field.key] || ''}
                    onChange={(e) => handleDynamicChange(field.key, e.target.value)}
                  >
                    <option value="">Select</option>
                    {field.options.map((opt, i) => (
                      <option key={i} value={opt}>{opt}</option>
                    ))}
                  </select>
                ) : null}
              </div>
            ))}


          <button className="new-contact-form-submit" type="submit">
            {isEditing ? 'Update Contact' : 'Save New Contact'}
          </button>
        </form>
        </div>
        
      </div>
    </div>
  );
}

export default NewContactForm;
